import React from 'react';
import { useMount } from './useMount';
var getFromWindow = function (property, defaultValue) {
    var _a;
    if (typeof window !== undefined) {
        return (_a = window[property]) !== null && _a !== void 0 ? _a : defaultValue;
    }
    return defaultValue;
};
export var useWindowSize = function () {
    var _a = React.useState(getFromWindow('innerWidth', 0)), width = _a[0], setWidth = _a[1];
    var _b = React.useState(getFromWindow('innerHeight', 0)), height = _b[0], setHeight = _b[1];
    var onResize = function () {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    };
    useMount(function () {
        window.addEventListener('resize', onResize);
        return function () {
            window.removeEventListener('resize', onResize);
        };
    });
    return { width: width, height: height };
};
